import * as React from 'react'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import ProductRow from 'src/components/molecules/configurator/ProductRow'
import ProductModal from 'src/components/molecules/configurator/ProductModal'
import { StoreProps } from 'src/stores'
import { ConfiguratorBox } from 'src/components/containers/configurator/ConfiguratorBox'

const coffinIcon = require('src/assets/configurator/coffin_icon.png')
const flowerIcon = require('src/assets/configurator/flower_icon.png')
const memorialIcon = require('src/assets/configurator/memorial_icon.png')
const urnIcon = require('src/assets/configurator/urn_icon.png')
const obituaryIcon = require('src/assets/configurator/obituary_icon.png')
const cardIcon = require('src/assets/configurator/card_icon.png')
const tombIcon = require('src/assets/configurator/tombs_icon.png')

interface Props extends StoreProps {
  index?: number
}

@inject('confStore')
@observer
export default class ProductConfigurator extends React.Component<Props> {
  render() {
    const { confStore, index } = this.props

    return (
      <ConfiguratorBox
        collapsable
        title={`${index}. Produkte`}
        idLabel={`expand-arrow-product-configurator`}>
        <Grid>
          {confStore.getOffer.funeralType != 'BURIAL' ? (
            <UrnProductRow confStore={confStore} />
          ) : (
            ''
          )}
          <CoffinProductRow confStore={confStore} />
          <FlowerProductRow confStore={confStore} />
          <ObituaryProductRow confStore={confStore} />
          <CardProductRow confStore={confStore} />
          <MemorialProductRow confStore={confStore} />
          <GraveyardServicesRow confStore={confStore} />
        </Grid>
      </ConfiguratorBox>
    )
  }
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 15px;
  grid-auto-rows: minmax(200px, auto);
`

const UrnProductRow = (props: StoreProps) => {
  const { confStore } = props
  const [modalOpen, setModalOpen] = React.useState(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  const products = confStore.getCatalogue.getProductsByType('URN')

  return (
    <>
      <ProductRow
        productType='URN'
        title='Urnen'
        defaultImg={urnIcon}
        defaultDesc='Wählen Sie aus einer Auswahl der gängigsten Urnenmodelle!'
        toOpenModal={openModal}
      />
      <ProductModal
        productType='URN'
        title='Unsere Urnen-Auswahl'
        open={modalOpen}
        onClose={closeModal}
        products={products}
        autoclose
      />
    </>
  )
}

const MemorialProductRow = (props: StoreProps) => {
  const { confStore } = props
  const [modalOpen, setModalOpen] = React.useState(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  const products = confStore.getCatalogue.getProductsByType('MEMORIAL')

  return (
    <>
      <ProductRow
        productType='MEMORIAL'
        title='Erinnerungsstücke'
        defaultImg={memorialIcon}
        defaultDesc='Wählen Sie aus einer Auswahl der schönsten Erinnerungsstücke!'
        toOpenModal={openModal}
      />
      <ProductModal
        productType='MEMORIAL'
        title='Erinnerungsstücke'
        open={modalOpen}
        onClose={closeModal}
        products={products}
        quantityselect
        multiselect
        maxQuantity={10}
      />
    </>
  )
}

const CoffinProductRow = (props: StoreProps) => {
  const { confStore } = props
  const [modalOpen, setModalOpen] = React.useState(false)
  const [variantModalOpen, setVariantModalOpen] = React.useState(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => {
    setModalOpen(false)
  }
  const openVariantModal = () => setVariantModalOpen(true)
  const closeVariantModal = () => {
    setVariantModalOpen(false)
  }

  const coffinProducts = confStore.getCatalogue.getProductsByType('COFFIN')
  const liningProducts = confStore.getCatalogue.getProductsByType('COFFIN_LINING')
  return (
    <>
      <ProductRow
        productType='COFFIN'
        title='Särge'
        defaultImg={coffinIcon}
        defaultDesc='Wählen Sie aus einer Auswahl der gängigsten Sargmodelle!'
        toOpenModal={openModal}
      />
      <ProductModal
        productType='COFFIN'
        title='Unsere Sarg-Auswahl'
        open={modalOpen}
        onClose={closeModal}
        products={coffinProducts}
        openVariantModal={openVariantModal}
        autoclose
      />
      <ProductModal
        productType='COFFIN_LINING'
        title='Unsere Sargeinbettungen und Sargkreuze'
        open={variantModalOpen}
        onClose={closeVariantModal}
        products={liningProducts}
        autoclose
        multiselect
      />
    </>
  )
}

const FlowerProductRow = (props: StoreProps) => {
  const { confStore } = props
  const [modalOpen, setModalOpen] = React.useState(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  const products = confStore.getCatalogue.getProductsByType('FLOWER')

  return (
    <>
      <ProductRow
        productType='FLOWER'
        title='Trauerfloristik'
        defaultImg={flowerIcon}
        defaultDesc='Wählen Sie aus einer Auswahl der schönsten Blumenarrangements!'
        toOpenModal={openModal}
      />
      <ProductModal
        productType='FLOWER'
        title='Unsere Trauerfloristik-Auswahl'
        open={modalOpen}
        onClose={closeModal}
        products={products}
        quantityselect
        multiselect
        maxQuantity={15}
      />
    </>
  )
}

const ObituaryProductRow = (props: StoreProps) => {
  const { confStore } = props
  const [modalOpen, setModalOpen] = React.useState(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)
  const checkProductAndClose = () => {
    closeModal()
  }
  const products = confStore.getCatalogue.getProductsByType('OBITUARY')

  return (
    <>
      <ProductRow
        productType='OBITUARY'
        title='Partezettel'
        defaultImg={obituaryIcon}
        defaultDesc='Wählen Sie aus einer Auswahl der schönsten Partezetteln!'
        toOpenModal={openModal}
      />
      <ProductModal
        productType='OBITUARY'
        title='Unsere Parten-Auswahl'
        open={modalOpen}
        onClose={checkProductAndClose}
        products={products}
        quantityselect
        quantityFactor={1}
        customQuantities={[10,20,30,40,50,60,70,80,90,100,125,150,175,200,250,300]}
      />
    </>
  )
}

const CardProductRow = (props: StoreProps) => {
  const { confStore } = props
  const [modalOpen, setModalOpen] = React.useState(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)

  const products = confStore.getCatalogue.getProductsByType('CARD')
  const checkProductAndClose = () => {
    closeModal()
  }
  return (
    <>
      <ProductRow
        productType='CARD'
        title='Gedenkbilder'
        defaultImg={cardIcon}
        defaultDesc='Wählen Sie aus einer Auswahl der schönsten Gedenkbilder!'
        toOpenModal={openModal}
      />
      <ProductModal
        productType='CARD'
        title='Unsere Gedenkbilder-Auswahl'
        open={modalOpen}
        onClose={checkProductAndClose}
        products={products}
        quantityselect
        quantityFactor={1}
        customQuantities={[10,20,30,40,50,60,70,80,90,100,125,150,175,200,250,300]}
      />
    </>
  )
}

const GraveyardServicesRow = (props: StoreProps) => {
  const { confStore } = props
  const [modalOpen, setModalOpen] = React.useState(false)

  const openModal = () => setModalOpen(true)
  const closeModal = () => setModalOpen(false)



  const products = confStore.getCatalogue.getProductsByType('TOMBS')
  
  const checkProductAndClose = () => {
    closeModal()
  }
  if(products.length > 0){
    return (
      <>
        <ProductRow
          productType='TOMBS'
          title='Grabanlagen'
          defaultImg={tombIcon}
          defaultDesc='Wählen Sie aus einer Auswahl der gängigsten Grabkreuze und Grabanlagen!'
          toOpenModal={openModal}
        />
        <ProductModal
          productType='TOMBS'
          title='Unsere Grabanlagen'
          open={modalOpen}
          onClose={checkProductAndClose}
          products={products}
          multiselect
          autoclose
        />
      </>  
  )
  }else{
    return <></>
  }
  
}


// WEBPACK FOOTER //
// ./src/components/organisms/configurator/ProductConfigurator.tsx